// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/get_vision_project.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { VisionProjectRole } from "./vision_project_pb";
import { file_vision_projects_v1_vision_project } from "./vision_project_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/get_vision_project.proto.
 */
export const file_vision_projects_v1_get_vision_project: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_vision_projects_v1_vision_project]);

/**
 * @generated from message protos.vision.projects.v1.GetVisionProjectRequest
 */
export type GetVisionProjectRequest = Message<"protos.vision.projects.v1.GetVisionProjectRequest"> & {
  /**
   * @generated from field: protos.vision.projects.v1.GetVisionProjectRequest.Params params = 1;
   */
  params?: GetVisionProjectRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.GetVisionProjectRequest.
 * Use `create(GetVisionProjectRequestSchema)` to create a new message.
 */
export const GetVisionProjectRequestSchema: GenMessage<GetVisionProjectRequest> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 0);

/**
 * @generated from message protos.vision.projects.v1.GetVisionProjectRequest.Params
 */
export type GetVisionProjectRequest_Params = Message<"protos.vision.projects.v1.GetVisionProjectRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: bool include_locations = 2;
   */
  includeLocations: boolean;

  /**
   * @generated from field: bool include_cast = 3;
   */
  includeCast: boolean;

  /**
   * @generated from field: bool include_props = 4;
   */
  includeProps: boolean;

  /**
   * @generated from field: bool include_shotlist_config = 5;
   */
  includeShotlistConfig: boolean;

  /**
   * @generated from field: bool include_shotlist_custom_presets = 6;
   */
  includeShotlistCustomPresets: boolean;
};

/**
 * Describes the message protos.vision.projects.v1.GetVisionProjectRequest.Params.
 * Use `create(GetVisionProjectRequest_ParamsSchema)` to create a new message.
 */
export const GetVisionProjectRequest_ParamsSchema: GenMessage<GetVisionProjectRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 0, 0);

/**
 * @generated from message protos.vision.projects.v1.GetVisionProjectResponse
 */
export type GetVisionProjectResponse = Message<"protos.vision.projects.v1.GetVisionProjectResponse"> & {
  /**
   * @generated from field: protos.vision.projects.v1.GetVisionProjectResponse.Result result = 1;
   */
  result?: GetVisionProjectResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.GetVisionProjectResponse.
 * Use `create(GetVisionProjectResponseSchema)` to create a new message.
 */
export const GetVisionProjectResponseSchema: GenMessage<GetVisionProjectResponse> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 1);

/**
 * @generated from message protos.vision.projects.v1.GetVisionProjectResponse.Result
 */
export type GetVisionProjectResponse_Result = Message<"protos.vision.projects.v1.GetVisionProjectResponse.Result"> & {
  /**
   * @generated from field: protos.vision.projects.v1.VisionProjectDetail project = 1;
   */
  project?: VisionProjectDetail | undefined;

  /**
   * @generated from field: protos.vision.projects.v1.VisionProjectRole my_role = 2;
   */
  myRole: VisionProjectRole;
};

/**
 * Describes the message protos.vision.projects.v1.GetVisionProjectResponse.Result.
 * Use `create(GetVisionProjectResponse_ResultSchema)` to create a new message.
 */
export const GetVisionProjectResponse_ResultSchema: GenMessage<GetVisionProjectResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 1, 0);

/**
 * @generated from message protos.vision.projects.v1.VisionProjectDetail
 */
export type VisionProjectDetail = Message<"protos.vision.projects.v1.VisionProjectDetail"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string owner_account_id = 4;
   */
  ownerAccountId: string;

  /**
   * @generated from field: int64 project_credits = 5;
   */
  projectCredits: bigint;

  /**
   * @generated from field: bool low_credits_notified = 6;
   */
  lowCreditsNotified: boolean;

  /**
   * @generated from field: string visionboard_rules = 7;
   */
  visionboardRules: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: repeated protos.vision.projects.v1.VisionProjectDetail.VisionLocation locations = 10;
   */
  locations: VisionProjectDetail_VisionLocation[];

  /**
   * @generated from field: repeated protos.vision.projects.v1.VisionProjectDetail.VisionCastMember cast = 11;
   */
  cast: VisionProjectDetail_VisionCastMember[];

  /**
   * @generated from field: repeated protos.vision.projects.v1.VisionProjectDetail.VisionProp props = 12;
   */
  props: VisionProjectDetail_VisionProp[];

  /**
   * @generated from field: protos.vision.projects.v1.VisionProjectDetail.ShotlistConfig shotlist_config = 13;
   */
  shotlistConfig?: VisionProjectDetail_ShotlistConfig | undefined;

  /**
   * @generated from field: repeated protos.vision.projects.v1.VisionProjectDetail.VisionShotlistCustomPreset shotlist_custom_presets = 14;
   */
  shotlistCustomPresets: VisionProjectDetail_VisionShotlistCustomPreset[];
};

/**
 * Describes the message protos.vision.projects.v1.VisionProjectDetail.
 * Use `create(VisionProjectDetailSchema)` to create a new message.
 */
export const VisionProjectDetailSchema: GenMessage<VisionProjectDetail> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 2);

/**
 * @generated from message protos.vision.projects.v1.VisionProjectDetail.VisionLocation
 */
export type VisionProjectDetail_VisionLocation = Message<"protos.vision.projects.v1.VisionProjectDetail.VisionLocation"> & {
  /**
   * @generated from field: string location_id = 1;
   */
  locationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string address = 3;
   */
  address: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.VisionProjectDetail.VisionLocation.
 * Use `create(VisionProjectDetail_VisionLocationSchema)` to create a new message.
 */
export const VisionProjectDetail_VisionLocationSchema: GenMessage<VisionProjectDetail_VisionLocation> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 2, 0);

/**
 * @generated from message protos.vision.projects.v1.VisionProjectDetail.VisionCastMember
 */
export type VisionProjectDetail_VisionCastMember = Message<"protos.vision.projects.v1.VisionProjectDetail.VisionCastMember"> & {
  /**
   * @generated from field: string cast_member_id = 1;
   */
  castMemberId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string color = 3;
   */
  color: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 4;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 5;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.VisionProjectDetail.VisionCastMember.
 * Use `create(VisionProjectDetail_VisionCastMemberSchema)` to create a new message.
 */
export const VisionProjectDetail_VisionCastMemberSchema: GenMessage<VisionProjectDetail_VisionCastMember> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 2, 1);

/**
 * @generated from message protos.vision.projects.v1.VisionProjectDetail.VisionProp
 */
export type VisionProjectDetail_VisionProp = Message<"protos.vision.projects.v1.VisionProjectDetail.VisionProp"> & {
  /**
   * @generated from field: string prop_id = 1;
   */
  propId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 4;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.VisionProjectDetail.VisionProp.
 * Use `create(VisionProjectDetail_VisionPropSchema)` to create a new message.
 */
export const VisionProjectDetail_VisionPropSchema: GenMessage<VisionProjectDetail_VisionProp> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 2, 2);

/**
 * @generated from message protos.vision.projects.v1.VisionProjectDetail.ShotlistConfig
 */
export type VisionProjectDetail_ShotlistConfig = Message<"protos.vision.projects.v1.VisionProjectDetail.ShotlistConfig"> & {
  /**
   * @generated from field: repeated string visible_columns = 1;
   */
  visibleColumns: string[];

  /**
   * @generated from field: repeated string column_order = 2;
   */
  columnOrder: string[];
};

/**
 * Describes the message protos.vision.projects.v1.VisionProjectDetail.ShotlistConfig.
 * Use `create(VisionProjectDetail_ShotlistConfigSchema)` to create a new message.
 */
export const VisionProjectDetail_ShotlistConfigSchema: GenMessage<VisionProjectDetail_ShotlistConfig> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 2, 3);

/**
 * @generated from message protos.vision.projects.v1.VisionProjectDetail.VisionShotlistCustomPreset
 */
export type VisionProjectDetail_VisionShotlistCustomPreset = Message<"protos.vision.projects.v1.VisionProjectDetail.VisionShotlistCustomPreset"> & {
  /**
   * @generated from field: string preset_id = 1;
   */
  presetId: string;

  /**
   * @generated from field: protos.vision.projects.v1.VisionProjectDetail.ShotlistPresetCategory category = 2;
   */
  category: VisionProjectDetail_ShotlistPresetCategory;

  /**
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * @generated from field: string label = 4;
   */
  label: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.VisionProjectDetail.VisionShotlistCustomPreset.
 * Use `create(VisionProjectDetail_VisionShotlistCustomPresetSchema)` to create a new message.
 */
export const VisionProjectDetail_VisionShotlistCustomPresetSchema: GenMessage<VisionProjectDetail_VisionShotlistCustomPreset> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_get_vision_project, 2, 4);

/**
 * @generated from enum protos.vision.projects.v1.VisionProjectDetail.ShotlistPresetCategory
 */
export enum VisionProjectDetail_ShotlistPresetCategory {
  /**
   * @generated from enum value: SHOTLIST_PRESET_CATEGORY_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SHOTLIST_PRESET_CATEGORY_FRAME_SIZE = 1;
   */
  FRAME_SIZE = 1,

  /**
   * @generated from enum value: SHOTLIST_PRESET_CATEGORY_ANGLE = 2;
   */
  ANGLE = 2,

  /**
   * @generated from enum value: SHOTLIST_PRESET_CATEGORY_CAMERA_MOVEMENT = 3;
   */
  CAMERA_MOVEMENT = 3,

  /**
   * @generated from enum value: SHOTLIST_PRESET_CATEGORY_EQUIPMENT = 4;
   */
  EQUIPMENT = 4,
}

/**
 * Describes the enum protos.vision.projects.v1.VisionProjectDetail.ShotlistPresetCategory.
 */
export const VisionProjectDetail_ShotlistPresetCategorySchema: GenEnum<VisionProjectDetail_ShotlistPresetCategory> = /*@__PURE__*/
  enumDesc(file_vision_projects_v1_get_vision_project, 2, 0);

